import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Table,
  Input,
  Button,
  message,
  Modal,
  Tag,
  Divider,
  Form,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  CopyOutlined,
  CreditCardOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import { withAppContext } from "contexts/AppContext/AppContext";
import {
  buildBillingSubscriptionUri,
  buildBillingManagementUri,
  buildBillingSubscriptionSpecialUri,
  buildDashboardUri,
} from "utils/routes";
import Highlighter from "react-highlight-words";
import moment from "moment";
import Currency from "react-currency-formatter";
import { PrimaryColor } from "utils/constants";
import {
  cancelUserSubscription,
  changeUserPaymentInformation,
  deleteUserBillingEmailRecipient,
  getUserBillings,
  getUserSubscription,
  patchUserBillingDetails,
  patchUserBillingEmailRecipients,
} from "apis/billing";
import { getAllProducts } from "apis/product";
import { getInvoice } from "apis/invoice";

import Locale from "react-intl-universal";

const Billing = ({ isAdmin, getLoggedInUser, getLoggedInUserSubscription }) => {
  const user = getLoggedInUser();

  const history = useHistory();
  const [receiptDetailsForm] = Form.useForm();
  const [billingEmailForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = useState(true);
  const [receiptDetailsVisible, setReceiptDetailsVisible] = useState(false);
  const [billingEmailVisible, setBillingEmailVisible] = useState(false);
  const [billingDetails, setBillingDetails] = useState({
    receiptDetails: {
      billingName: "",
      billingAddress: "",
    },
  });

  const [billingEmailRecipients, setBillingEmailRecipients] = useState([]);
  const [data, setData] = useState([]);
  const [billingLoading, setBillingLoading] = useState(true);

  const [searchText, setSearchText] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [userSubscription, setUserSubscription] = useState([]);

  // const onBackButtonClick = () => history.goBack();
  const onBackButtonClick = () => history.push(buildDashboardUri());

  useEffect(() => {
    getCurrentSubscription();

    console.log("user", user);

    var latestReceiptDetail;

    latestReceiptDetail = {
      receiptDetails: {
        billingName: user.billingName,
        billingAddress: user.billingAddress,
      },
    };

    setBillingDetails(latestReceiptDetail);

    const billingEmailRecipients = user.billingEmailRecipients
      ? user.billingEmailRecipients
      : [];
    setBillingEmailRecipients(billingEmailRecipients);
    receiptDetailsForm.setFieldsValue({
      billingName: user.billingName,
      billingAddress: user.billingAddress,
    });
    return () => {};
  }, [user.name]);

  const getCurrentSubscription = async () => {
    setSubscriptionLoading(true);
    const currentSubscription = await getLoggedInUserSubscription();

    setUserSubscription(currentSubscription);
    if (currentSubscription.length > 0) {
      if (currentSubscription[0].customerId) {
        BillingHistory(currentSubscription[0].customerId);
      } else {
        setBillingLoading(false);
      }
    } else {
      setBillingLoading(false);
    }
    setSubscriptionLoading(false);
  };

  const BillingHistory = async (customerId) => {
    setBillingLoading(true);
    const res = await getUserBillings(customerId);
    console.log("res", res);

    if (res.status === 200) {
      const buffer = [...res.billings.data];

      buffer.forEach((billing) => {
        billing.invoiceNumber = billing.metadata.invoiceNumber;
      });
      setData(buffer);
      setBillingLoading(false);
    }
  };

  const HandleReceiptDetails = async () => {
    const values = await receiptDetailsForm.validateFields();

    console.log("values HandleReceiptDetails", values);

    Modal.confirm({
      title: Locale.get("Billing.confirmAdd"),
      onOk: () => {
        patchUserBillingDetails(values)
          .then((res) => {
            console.log("res patchUserBillingDetails", res);
            if (res.status === 200) {
              setReceiptDetailsVisible(false);
              message.success(Locale.get("Billing.confirmAddSuccess"));

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((ex) => {
            Modal.error({
              title: ex.message,
            });
          });
      },
    });
  };

  const HandleBillingEmail = async () => {
    const values = await billingEmailForm.validateFields();

    console.log(values);

    Modal.confirm({
      title: Locale.get("Billing.confirmAddBillingEmail"),
      onOk: () => {
        const payload = {
          billingEmailRecipient: values.email,
        };
        patchUserBillingEmailRecipients(payload)
          .then((res) => {
            console.log("res patchUserBillingEmailRecipients", res);
            if (res.status === 200) {
              setBillingEmailVisible(false);
              message.success("Add Billing Email Recipients Successful!");

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((ex) => {
            Modal.error({
              title: ex.message,
            });
          });
      },
    });
  };

  const CancelSubscription = async (status) => {
    Modal.confirm({
      width: 800,
      content:
        status === "past_due"
          ? "Note that your current subscription will be canceled immediately and you will lose access to the resources provided by your current subscription. Past subscription fees won't be refunded."
          : `Note that your current subscription will be canceled on ${moment
              .unix(userSubscription[0].endDate)
              .format(
                "YYYY-MM-DD"
              )} and you will lose access to the resources provided by your current subscription. Past subscription fees won't be refunded.`,

      title: "Are you sure you want to cancel your subscription? ",
      onOk: async () => {
        cancelUserSubscription()
          .then((res) => {
            if (res.status === 200) {
              message.success("Your subscription has been cancel successully!");

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((ex) => {
            Modal.error({
              title: ex.message,
            });
          });
      },
    });
  };

  const HandleDeleteEmail = async (value) => {
    const payload = {
      billingEmailRecipient: value,
    };
    deleteUserBillingEmailRecipient(payload)
      .then((res) => {
        console.log("res deleteUserBillingEmailRecipient", res);
        if (res.status === 200) {
          setBillingEmailVisible(false);
          message.success("Delete Billing Email Recipients Successful!");

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((ex) => {
        Modal.error({
          title: ex.message,
        });
      });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 8 },
      xl: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16 },
      xl: { span: 16 },
    },
  };

  const formCustomLayout = {
    // labelCol: {
    //   xs: { span: 24 },
    //   md: { span: 8 },
    //   xl: { span: 8 }
    // },
    wrapperCol: {
      xs: { span: 24 },
      md: { offset: 8, span: 16 },
      xl: { offset: 8, span: 16 },
    },
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          marginRight: 8,
          fontSize: 18,
          color: filtered ? "#ffc069" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      console.log(record);
      if (record[dataIndex]) {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return false;
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput);
      }
    },
    render: (text) => {
      if (text) {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        );
      }
    },
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: Locale.get("Billing.billingComponent.statusComponent"),
      dataIndex: "status",
      key: "status",
      filterMultiple: false,
      filters: [
        { text: <Tag color="green">Paid</Tag>, value: "paid" },
        { text: <Tag color="blue">Open</Tag>, value: "open" },
        // { text: <Tag color="yellow">Draft</Tag>, value: "draft" },
        // { text: <Tag>Uncollectible</Tag>, value: "uncollectible" },
        // { text: <Tag color="red">Void</Tag>, value: "void" },
      ],

      onFilter: (value, record) => {
        return record.status === value;
      },

      render: (value) => {
        switch (value) {
          case "paid":
            return <Tag color="green">Paid</Tag>;

          case "open":
            return <Tag color="blue">Open</Tag>;

          // case "draft":
          //   return <Tag color="yellow">Draft</Tag>;

          // case "uncollectible":
          //   return <Tag>Uncollectible</Tag>;

          default:
            // return <Tag color="red">Void</Tag>;
            return <Tag color="blue">Open</Tag>;
        }
      },
    },
    {
      title: Locale.get("Billing.billingComponent.invoiceNo"),
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",

      ...getColumnSearchProps("invoiceNumber"),
      render: (v) =>
        v ? (
          <div style={{ cursor: "pointer" }}>
            <CopyOutlined
              style={{
                marginRight: 8,
                color: "#1890ff",
              }}
            />
            <a
              onClick={async () => {
                const invoiceNumber = v;

                // history.push(
                //   `invoice/subscription?invoiceNumber=${invoiceNumber}`
                // );
                setBillingLoading(true);
                let pdfURL;
                const encoding = "base64";
                getInvoice(invoiceNumber, encoding)
                  .then((res) => {
                    const decodedData = atob(res);
                    const bytes = new Uint8Array(decodedData.length);
                    for (let i = 0; i < decodedData.length; i++) {
                      bytes[i] = decodedData.charCodeAt(i);
                    }
                    const blob = new Blob([bytes.buffer], {
                      type: "application/pdf",
                    });

                    pdfURL = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = pdfURL;
                    link.download = "finport-subscription-invoice.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setBillingLoading(false);
                    URL.revokeObjectURL(pdfURL);
                  })
                  .catch((ex) => {
                    Modal.error({
                      title: ex.message,
                    });
                  });
              }}
              style={{ color: "#1890ff", borderBottom: "1px solid #1890ff" }}
            >
              {v}
            </a>
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: Locale.get("Billing.billingComponent.totalComponent"),
      dataIndex: "total",
      key: "total",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.total - b.total,
      render: (v, d) => (
        <Currency
          quantity={v / 100}
          currency={d.currency}
          pattern="! #,##0.00"
        />
      ),
    },
    {
      title: Locale.get("Billing.billingComponent.issueComponent"),
      dataIndex: "created",
      key: "created",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment.unix(a.created) - moment.unix(b.created),

      render: (v) => {
        return moment.unix(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.billingComponent.dueComponent"),
      dataIndex: "due_date",
      key: "due_date",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment.unix(a.due_date) - moment.unix(b.due_date),

      render: (v) => {
        if (v) {
          return moment.unix(v).format("YYYY-MM-DD");
        } else {
          return "-";
        }
      },
    },
  ];

  const ReceiptDetailsModal = (
    <Modal
      title={Locale.get("Billing.modalTitle")}
      visible={receiptDetailsVisible}
      // afterClose={() => {
      //   form.resetFields();
      //   setTestcontact();
      // }}
      onCancel={() => setReceiptDetailsVisible(false)}
      onOk={HandleReceiptDetails}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <Form {...formItemLayout} form={receiptDetailsForm} scrollToFirstError>
        <Form.Item
          name="billingName"
          label={Locale.get("Billing.billingName")}
          rules={[
            {
              required: true,
              message: Locale.get("Billing.billNameRuleMsg"),
            },
          ]}
        >
          <Input placeholder="John Doe" disabled={loading} />
        </Form.Item>
        <Form.Item
          label={Locale.get("Billing.billingAddress")}
          name="billingAddress"
          rules={[
            {
              required: true,
              message: Locale.get("Billing.billAddressRuleMsg"),
            },
          ]}
        >
          <Input.TextArea
            disabled={loading}
            autoSize={{ minRows: 5, maxRows: 5 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );

  const BillingEmailModal = (
    <Modal
      title={Locale.get("Billing.emailModalTitle")}
      visible={billingEmailVisible}
      afterClose={() => {
        billingEmailForm.resetFields();
      }}
      onCancel={() => setBillingEmailVisible(false)}
      footer={null}
      // onOk={HandleBillingEmail}
      // okButtonProps={{ loading: loading }}
      // cancelButtonProps={{ disabled: loading }}
    >
      <Form
        {...formItemLayout}
        form={billingEmailForm}
        scrollToFirstError
        onFinish={HandleBillingEmail}
      >
        <Form.Item
          name="email"
          label={Locale.get("Billing.emailLabel")}
          rules={[
            {
              required: true,
            },
            {
              type: "email",
              message: Locale.get("Billing.emailRuleMsg"),
            },
            //   {
            //     validator: CheckEmailExist
            //   }
          ]}
        >
          <Input placeholder="example@finport.com" disabled={loading} />
        </Form.Item>

        <Form.Item {...formCustomLayout}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={billingEmailRecipients?.length < 5 ? false : true}
            icon={<PlusOutlined />}
          >
            {Locale.get("Billing.emailModalTitle")}
          </Button>
        </Form.Item>
      </Form>

      <Divider />

      <Row
        justify="center"
        style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}
      >
        {Locale.get("Billing.rowHeaderBillingEmail")}
      </Row>

      {billingEmailRecipients?.length > 0
        ? billingEmailRecipients?.map((value, index) => (
            <Row
              key={index}
              align="middle"
              justify="space-between"
              style={{ marginBottom: 8 }}
            >
              <Col
                style={{
                  fontSize: 16,
                  color: "rgba(0,0,0,0.45)",
                  fontWeight: 500,
                }}
              >
                {value}
              </Col>

              <Col>
                <Button
                  type="link"
                  style={{ color: "red", fontWeight: 500 }}
                  onClick={() =>
                    Modal.confirm({
                      title: Locale.get("Billing.confirmDeleteBillingEmail"),
                      onOk: () => {
                        HandleDeleteEmail(value);
                      },
                    })
                  }
                >
                  {Locale.get("Billing.dltEmailButton")}
                </Button>
              </Col>
            </Row>
          ))
        : "- N/A"}
    </Modal>
  );

  const handleManagePaymentInformation = async () => {
    const customerId = userSubscription[0].customerId;
    const payload = {
      customerId: customerId,
      domain: window.location.origin,
    };
    changeUserPaymentInformation(payload)
      .then((res) => {
        if (res.status === 200) {
          message.success("Portal session successfully created!");
          console.log("res", res);
          setTimeout(() => {
            window.location.assign(res.redirectUrl);
          }, 250);
        }
      })
      .catch((ex) => {
        Modal.error({
          title: ex.message,
        });
      });
  };

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "32px" }}
      >
        <ClickableTextButton
          text={Locale.get("Billing.backButton")}
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
        {/* <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleOnSaveButtonClick}>
          Save
        </Button> */}
      </Row>

      <Row
        align="middle"
        justify="space-between"
        gutter={24}
        style={{ marginBottom: 32 }}
      >
        <Col>
          <Row gutter={24} align="middle">
            <Col>
              <Title /* marginBottom="32px" */>
                {Locale.get("Billing.pageTitle")}
              </Title>
            </Col>

            {isAdmin && (
              <Col>
                <Button
                  type="primary"
                  onClick={() => history.push(buildBillingManagementUri())}
                >
                  {Locale.get("Billing.bma")}
                </Button>
              </Col>
            )}
          </Row>
        </Col>

        <Col>
          {userSubscription.length > 0 && userSubscription[0].customerId && (
            <Button
              type="primary"
              onClick={() => {
                handleManagePaymentInformation();
              }}
              icon={<CreditCardOutlined />}
            >
              Update Payment Information
            </Button>
          )}
        </Col>
      </Row>

      <Row gutter={24}>
        <Col xs={24} md={24} xl={9}>
          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
              marginBottom: 24,
            }}
          >
            <Row justify="space-between" align="middle">
              <Col style={{ fontWeight: "bold", fontSize: 18, color: "#000" }}>
                {userSubscription.length > 0
                  ? userSubscription[0].planName
                  : Locale.get("Billing.noSub")}
              </Col>
              {((userSubscription.length > 0 &&
                !userSubscription[0]?.customerId) ||
                userSubscription.length === 0) && (
                <Col>
                  <Button
                    type="primary"
                    disabled={
                      userSubscription.length > 0
                        ? // Allow subscribe-trial
                          userSubscription[0]?.subscriptionStatus === "trialing"
                          ? false
                          : //Disable when subscription is past_due
                          //Disable for indonesian users
                          userSubscription[0]?.subscriptionStatus !==
                              "active" || !userSubscription[0]?.customerId
                          ? true
                          : false
                        : false
                    }
                    onClick={() => {
                      console.log(user, 837);

                      if (!user.billingName || !user.billingAddress) {
                        return setReceiptDetailsVisible(true);
                      }
                      if (
                        userSubscription.length > 0 &&
                        userSubscription[0]?.subscriptionStatus !== "trialing"
                      ) {
                        if (userSubscription[0].productVisibility) {
                          history.push(buildBillingSubscriptionUri());
                        } else {
                          //special products
                          history.push(
                            `${buildBillingSubscriptionSpecialUri()}?productId=${
                              userSubscription[0].productId
                            }`
                          );
                        }
                      } else {
                        history.push(buildBillingSubscriptionUri());
                      }
                    }}
                    loading={subscriptionLoading}
                  >
                    {Locale.get("Billing.upgrade")}
                  </Button>
                </Col>
              )}
            </Row>
            {userSubscription.length > 0 && userSubscription[0].customerId && (
              <Row
                justify="space-between"
                align="middle"
                style={{ marginTop: 8 }}
              >
                <Col>
                  <Button
                    type="primary"
                    onClick={() => {
                      CancelSubscription(
                        userSubscription[0].subscriptionStatus
                      );
                    }}
                    danger
                    disabled={userSubscription[0].cancelAtEndDate}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    {userSubscription[0].cancelAtEndDate
                      ? "Cancelled"
                      : "Cancel Subscription"}
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    disabled={
                      userSubscription[0]?.subscriptionStatus === "trialing"
                        ? false
                        : userSubscription[0]?.subscriptionStatus !==
                            "active" || !userSubscription[0]?.customerId
                        ? true
                        : false
                    }
                    onClick={() => {
                      if (!user.billingName || !user.billingAddress) {
                        return setReceiptDetailsVisible(true);
                      }
                      if (userSubscription.length > 0) {
                        if (userSubscription[0].productVisibility) {
                          history.push(buildBillingSubscriptionUri());
                        } else {
                          //special products
                          history.push(
                            `${buildBillingSubscriptionSpecialUri()}?productId=${
                              userSubscription[0].productId
                            }`
                          );
                        }
                      } else {
                        history.push(buildBillingSubscriptionUri());
                      }
                    }}
                    loading={subscriptionLoading}
                  >
                    Upgrade Now
                  </Button>
                </Col>
              </Row>
            )}
          </div>

          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
              marginBottom: 24,
            }}
          >
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: 16 }}
            >
              <Col
                style={{
                  backgroundColor: "#f2f2f2",
                  borderRadius: " 0px 4px 4px 0px",
                  color: "#000",
                  fontSize: 16,
                  fontWeight: "bold",
                  padding: "8px 16px",
                  transform: "translate(-16px, 0px)",
                }}
              >
                {Locale.get("Billing.receiptDetail")}
              </Col>
              <Col>
                <Button
                  type="link"
                  style={{
                    color: PrimaryColor,
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                  onClick={() => setReceiptDetailsVisible(true)}
                >
                  {Locale.get("Billing.addButton")}
                </Button>
              </Col>
            </Row>

            {/* <Divider style={{ margin: '12px 0px' }} /> */}

            <Row style={{ fontSize: 16, fontWeight: 500 }}>
              {Locale.get("Billing.billingName")}
            </Row>

            <Row
              style={{
                fontSize: 14,
                color: "rgba(0,0,0,0.45)",
                fontWeight: 500,
                marginBottom: 12,
              }}
            >
              {billingDetails.receiptDetails.billingName
                ? billingDetails.receiptDetails.billingName
                : "N/A"}
            </Row>

            <Row style={{ fontSize: 16, fontWeight: 500 }}>
              {Locale.get("Billing.billingAddress")}
            </Row>

            <Row
              style={{
                fontSize: 14,
                color: "rgba(0,0,0,0.45)",
                fontWeight: 500,
                textAlign: "justify",
              }}
            >
              {billingDetails.receiptDetails.billingAddress
                ? billingDetails.receiptDetails.billingAddress
                : "N/A"}
            </Row>
          </div>

          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
              marginBottom: 24,
            }}
          >
            <Row
              justify="space-between"
              align="middle"
              style={{
                marginBottom: 16,
              }}
            >
              <Col
                style={{
                  backgroundColor: "#f2f2f2",
                  borderRadius: " 0px 4px 4px 0px",
                  color: "#000",
                  fontSize: 16,
                  fontWeight: "bold",
                  padding: "8px 16px",
                  transform: "translate(-16px, 0px)",
                }}
              >
                {Locale.get("Billing.emailRecipient")}
              </Col>
              <Col>
                <Button
                  type="link"
                  style={{
                    color: PrimaryColor,
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                  onClick={() => setBillingEmailVisible(true)}
                >
                  {Locale.get("Billing.addButton")}
                </Button>
              </Col>
            </Row>

            {/* <Divider style={{ margin: '12px 0px' }} /> */}

            {billingEmailRecipients?.length > 0
              ? billingEmailRecipients?.map((value, index) => {
                  return (
                    <Row
                      key={index}
                      style={{
                        fontSize: 14,
                        color: "rgba(0,0,0,0.45)",
                        fontWeight: 500,
                      }}
                    >
                      - {value}
                    </Row>
                  );
                })
              : "- N/A"}
          </div>
        </Col>

        <Col xs={24} md={24} xl={15}>
          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
            }}
          >
            <Row>
              <Col
                style={{
                  backgroundColor: "#f2f2f2",
                  borderRadius: " 0px 4px 4px 0px",
                  color: "#000",
                  fontSize: 16,
                  fontWeight: "bold",
                  padding: "8px 16px",
                  marginBottom: 16,
                  transform: "translate(-16px, 0px)",
                }}
              >
                {Locale.get("Billing.billingHistory")}
              </Col>
            </Row>
            <Table
              size="small"
              rowKey="id"
              bordered
              columns={columns}
              loading={billingLoading}
              dataSource={data}
              scroll={{ scrollToFirstRowOnChange: true, x: true }}
            />
          </div>
        </Col>
      </Row>

      {ReceiptDetailsModal}
      {BillingEmailModal}
    </div>
  );
};

export default withAppContext(Billing);
